import { useFormikContext } from "formik";
import { useListedAlgo } from "../../lazertrader/contexts/listAlgosContext";
import { usePrefillContext } from "../../../Services/PrefillContextProvider";
import { ConfigTabState } from "../types";
import { Button } from "@mui/material";

export const CancelButton = () => {
  const { setSelectedAlgos } = useListedAlgo();
  // Clearing the prefill too, otherwise cancelling an add leaves the popup open
  // on a form it has just reset.
  const { reset } = usePrefillContext();
  const { initialValues, values, resetForm } =
    useFormikContext<ConfigTabState>();

  return (
    <Button
      sx={{ flex: 1 }}
      color="error"
      onClick={() => {
        setSelectedAlgos([]);
        reset();
        // `?? initialValues.behavior` for the same reason as `customResetForm`:
        // a shimurai algo leaves `values.behavior` unset, and that must not
        // carry into the next new algo.
        resetForm({
          values: {
            ...initialValues,
            behavior: values.behavior ?? initialValues.behavior,
          },
        });
      }}
      variant="contained"
    >
      Cancel
    </Button>
  );
};
